import { render, staticRenderFns } from "./BackofficeFarmacia.vue?vue&type=template&id=7d7c8f54"
import script from "./BackofficeFarmacia.vue?vue&type=script&lang=ts"
export * from "./BackofficeFarmacia.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports